module.exports = __webpack_public_path__ + "img/step-3-car.ee09ac57.svg";